import { useAuthStore } from '../../stores/useAuthStore';
import { auth } from '../../utils/firebase';
import { sendEmailVerification } from 'firebase/auth';
import { toggleModal } from '../../utils/uiUtils';
import { _requestMyData } from '../../data/users';

function RequestMyData() {
    var emailVerified = useAuthStore((state) => state?.user?.emailVerified)

    const sendVerificationEmail = async () => {
        try {
            await sendEmailVerification(auth.currentUser);
            toggleModal('modal-emailSent');
        } catch (error) {
            console.error('Error sending verification email:', error);
        }
    };

    const checkVerificationStatus = async () => {
        try {
            // Reload user data from Firebase
            await auth.currentUser.reload();

            // Update the auth store with fresh user data
            const updatedUser = {
                ...auth.currentUser,
                emailVerified: auth.currentUser.emailVerified
            };

            useAuthStore.getState().setUser(updatedUser);
            toggleModal('modal-emailSent');
        } catch (error) {
            console.error('Error checking verification status:', error);
        }
    };

    const requestMyData = async () => {
        await _requestMyData();
        toggleModal("modal-dataRequested");
        document.getElementById("dataRequestButton").disabled = true;
    }

    return (
        <>
            <div className="is-size-5 has-text-weight-bold is-underlined mt-5">
                Request my data
            </div>
            {!emailVerified &&
                <div>
                    Your email address is not verified. In order to request your data, you will first need to verify your email.
                    <div className="buttons">
                        <button
                            className="button is-primary"
                            onClick={sendVerificationEmail}>
                            Send Verification Email
                        </button>
                    </div>
                </div>
            }

            {emailVerified &&
                <>
                    <div>
                        You can request a copy of your data be emailed to you using the button below. If there is already a pending request for your data, clicking
                        the button a second time will not submit a new request.
                        <div className="buttons">
                            <button
                                id="dataRequestButton"
                                className="button is-primary"
                                onClick={requestMyData}>
                                Request My Data
                            </button>
                        </div>
                    </div>
                </>
            }

            <div id="modal-emailSent" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Verification Email Sent</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-emailSent') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="is-size-6">
                            A verification email with a link has been sent to your email address.
                            Please check your inbox and click the link to verify your email, then come back here and click the "Confirm Email Verification" button.
                        </div>
                    </section>
                    <footer className="modal-card-foot">

                        <button className="button is-primary ml-4" onClick={checkVerificationStatus}>Check Verification Status</button>
                        <button className="button mr-5" aria-label="close" onClick={() => { toggleModal('modal-emailSent') }}>Close</button>
                    </footer>
                </div>
            </div>

            <div id="modal-dataRequested" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Data Request Accepted</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-dataRequested') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="is-size-6">
                            Your request to send you your data has been accepted. You should receive an email with your data. This will not be immediate, as it takes some time to process.
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button mr-5" aria-label="close" onClick={() => { toggleModal('modal-dataRequested') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    )
}

export default RequestMyData;